import { render, staticRenderFns } from "./PatientDischargeAgainstAdvicePrint.vue?vue&type=template&id=200820ec&scoped=true"
import script from "./PatientDischargeAgainstAdvicePrint.vue?vue&type=script&lang=js"
export * from "./PatientDischargeAgainstAdvicePrint.vue?vue&type=script&lang=js"
import style0 from "./PatientDischargeAgainstAdvicePrint.vue?vue&type=style&index=0&id=200820ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200820ec",
  null
  
)

export default component.exports